var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1202_11325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 0C5.14391 0 3.36219 0.737953 2.05078 2.05023C0.738281 3.36252 0 5.14423 0 7C0 8.85577 0.738281 10.6375 2.05078 11.9498C3.36219 13.262 5.14391 14 7 14C8.85609 14 10.6378 13.262 11.9492 11.9498C13.2617 10.6375 14 8.85577 14 7C14 5.14423 13.2617 3.36252 11.9492 2.05023C10.6378 0.737953 8.85609 0 7 0Z",
    fill: "url(#paint0_linear_1202_11325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.16901 6.92598C5.20995 6.03698 6.57055 5.45083 7.25087 5.16766C9.19555 4.35905 9.59913 4.21862 9.86273 4.21391C9.9207 4.21293 10.0498 4.22726 10.134 4.2954C10.204 4.35282 10.2237 4.43048 10.2335 4.48494C10.2423 4.53941 10.2543 4.66355 10.2445 4.76046C10.1395 5.86734 9.68338 8.55337 9.4515 9.79313C9.35416 10.3177 9.16055 10.4936 8.97352 10.5108C8.56665 10.5482 8.25819 10.2421 7.86444 9.9841C7.24866 9.58018 6.90087 9.32884 6.30259 8.93476C5.61134 8.47932 6.05977 8.22896 6.45352 7.8199C6.55633 7.71282 8.34788 6.08368 8.38179 5.93591C8.38616 5.91743 8.39056 5.84852 8.349 5.81221C8.30853 5.77579 8.24834 5.78826 8.20459 5.7981C8.14224 5.8121 7.15896 6.46266 5.25146 7.74968C4.97255 7.94152 4.7199 8.03504 4.4924 8.03012C4.24303 8.02476 3.76181 7.8888 3.40416 7.77265C2.96666 7.63013 2.61773 7.55477 2.64836 7.31273C2.66367 7.18673 2.8376 7.05777 3.16901 6.92598Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1202_11325",
    x1: 7,
    y1: 0,
    x2: 7,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1202_11325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.edd937c1fb947194c370f8166c6b4189.svg";
export { ForwardRef as ReactComponent };